import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
import TrainingFilters from '../TrainingFilters/TrainingFilters';

const TrainingHero = ({
  searchTerm,
  onSearchChange,
  selectedLevel,
  onLevelChange,
  selectedTrainingType,
  onTrainingTypeChange,
  selectedModality,
  onModalityChange,
  levels,
  trainingTypes,
  trainingTypeValueToLabel,
  modalities,
  resultCount,
  onResetFilters,
  filteredTrainings = []
}) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-purple-50 to-violet-50 py-20 lg:py-28">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 mb-16">
          <div className="text-center lg:text-left lg:w-1/2">
            {/* Título com Gradiente */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl lg:text-7xl font-black text-gray-900 mb-8 leading-[0.95] tracking-tighter"
            >
              <span
                className="bg-clip-text text-transparent"
                style={{
                  backgroundImage: 'linear-gradient(to right, rgb(124, 58, 237) 0%, rgb(147, 51, 234) 25%, rgb(139, 92, 246) 50%, rgb(124, 58, 237) 50%, rgb(147, 51, 234) 75%, rgb(139, 92, 246) 100%)'
                }}
              >
                TREINAMENTOS
                <br />
                LUKOS
              </span>
            </motion.h1>

            {/* Descrição */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-xl md:text-2xl text-gray-500 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-medium"
            >
              Domine todas as funcionalidades do ecossistema Lukos com nossos treinamentos práticos,
              ministrados por especialistas do sistema.
            </motion.p>
          </div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9, x: 30 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="lg:w-1/2 relative"
          >
            <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl border-4 border-white">
              <img 
                src="/assets/training/meet_session.png" 
                alt="Lukos Online Training" 
                className="w-full h-full object-cover aspect-[4/3]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/10 to-transparent"></div>
            </div>
            {/* Floating badge */}
            <motion.div 
              animate={{ y: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
              className="absolute -bottom-6 -left-6 bg-white p-6 rounded-3xl shadow-xl border border-slate-100 hidden md:block"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-purple-100 rounded-2xl flex items-center justify-center text-purple-600">
                  <PlayCircle size={24} />
                </div>
                <div>
                  <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">Próxima Live</p>
                  <p className="text-sm font-black text-slate-900">Hoje às 15:00</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* Filtros no rodapé do hero */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <TrainingFilters
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            selectedLevel={selectedLevel}
            onLevelChange={onLevelChange}
            selectedTrainingType={selectedTrainingType}
            onTrainingTypeChange={onTrainingTypeChange}
            selectedModality={selectedModality}
            onModalityChange={onModalityChange}
            levels={levels}
            trainingTypes={trainingTypes}
            trainingTypeValueToLabel={trainingTypeValueToLabel}
            modalities={modalities}
            resultCount={resultCount}
            onResetFilters={onResetFilters}
            filteredTrainings={filteredTrainings}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default React.memo(TrainingHero);

